import { Icon, For, location } from 'cdui-js';
import { userState } from '../../../stores/user';
import { gotoLogin, getImageUrl } from '../utils/common';
import { MENU_LIST, MenuItem } from './conf.tsx';
import { DefaultUserIcon } from '../icons';
import { DiFiImg } from '../../../components/DiFi/DiFiImg/index.tsx';
import { ensureAsyncIcons } from '../../../lib/ensure-async-icons';

void ensureAsyncIcons();

const MyPage = () => {
  return (
    <div class="my-page height-100 relative">
      <div class="user-login-bg absolute top-0 left-0 right-0 height-160px"></div>

      <div class="content relative z-10">
        <div class="setting-btn padding-x-L flex justify-end align-center color-D gap-16px" style="height:54px">
          <Icon name="my-theme" class={`icon-s-XL icon-c-D`}></Icon>
          <Icon name="mail" class={`icon-s-XL icon-c-D`} onclick={() => location.routeTo('/message', [0, 0])}></Icon>
        </div>

        <div
          class="user-login flex align-center justify-start padding-x-L"
          style={{ 'margin-top': '32px' }}
          onclick={() => (userState.isLogin ? location.routeTo('/user-info', [0, 0]) : gotoLogin())}
        >
          <div class="user-login-avatar" style={{ background: 'transparent', height: '72px' }}>
            {userState.icon ? (
              <DiFiImg
                src={getImageUrl(userState.icon)}
                alt=""
                class="user-login-avatar-img"
                errorIcon={<DefaultUserIcon />}
              />
            ) : (
              <DefaultUserIcon />
            )}
          </div>
          <div
            class="user-login-info margin-l flex-column justify-space-between"
            style={{ height: '60px', gap: '7px' }}
          >
            {userState.isLogin ? (
              <div class="color-D font-s-XL" style={{ 'line-height': '34px', 'font-weight': '400' }}>
                {userState.nickName || userState.userName}
              </div>
            ) : (
              <div
                class="color-D font-s-XL"
                style={{ 'line-height': '34px', 'font-weight': '400' }}
                onclick={gotoLogin}
              >
                点击登录
              </div>
            )}

            <div class="flex-row align-start font-s-XS" style={{ 'line-height': '18px', height: '18px', gap: '16px' }}>
              <div class="color-L flex-row align-center justify-center">
                <span class="stock-icon-text margin-r-XXS color-primary">HK</span>
                <span class="color-L">延时</span>
              </div>
              <div class="color-L flex-row align-center justify-center">
                <span class="stock-icon-text margin-r-XXS color-primary">US</span>
                <span class="color-L">延时</span>
              </div>
            </div>
          </div>
        </div>

        <div class="pannel padding-x-L" style={{ 'margin-top': '40px' }}>
          <div class="pannel-content margin-t-Sflex-column gap-16px">
            <For each={MENU_LIST}>
              {(item: MenuItem) => {
                const iconClass = item.iconClass || null;
                const Cmp = item.IconRender;
                return (
                  <div
                    class="item flex-row align-center justify-space-between  gap-16px padding-y-L"
                    style="line-height: 24px;min-height: 24px;"
                    onclick={() => {
                      if (!['/about-us', '/settings'].includes(item.path) && !userState.isLogin) {
                        userState.showLoginPage = true;
                      } else {
                        location.routeTo(item.path, [0, 0]);
                      }
                    }}
                  >
                    <div class="flex-row align-center justify-center gap-16px">
                      <Cmp class={iconClass} />
                      <span class="font-s-XS color-D">{item.text}</span>
                    </div>
                    <Icon name="common-arrow-right" class="icon-s-S icon-c-D font-s"></Icon>
                  </div>
                );
              }}
            </For>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyPage;
